<template>
    <div class="result-class">
        <div style="height: 100%;width: 100%;background-color: white">
        <div style="margin-top: 42vh; margin-left: 3.5vw;border-radius: 15px;width: 95%;height: 100%">

            <el-table
                    :data="userRankingData"
                    stripe
                    :row-class-name="rowClassName"
                    style="width: 100%;border-radius: 10px"
                    header-cell-class-name="tableStyle">
                <el-table-column
                        label="序号"
                        width="100vw">
                    <template slot-scope="scope">
                        <span>{{scope.row.xh}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="答题时间"
                        width="150vw">
                    <template slot-scope="scope">
                        <span>{{scope.row.subTime |formatDateDay}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="userFraction"
                        width="130vw"
                        label="分数">
                </el-table-column>
            </el-table>
        </div>
    </div>
    </div>
</template>
<script>
    import {queryResultByDate} from "@api/test";
    import {formatDate} from "@api/date.js";

    export default {
        name: "PersonResult",
        components: {},
        props: {},

        data: function () {
            return {
                padDate: function (value) {
                    return value < 10 ? '0' + value : value;
                },
                userRankingData: [],
            };
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd hh:mm");
            }
        },
        mounted: function () {
            this.getResultByDate();
        },
        methods: {
            rowClassName({row, rowIndex}) {
                row.xh = rowIndex + 1;
            },
            getResultByDate() {
                let loading = this.$weui.loading("数据加载中");
                var params = {}
                queryResultByDate(params).then(response => {
                    this.userRankingData = response.userResult;
                    // console.log( response.lessonList)
                });
                loading.hide();
                console.log("团课内容");
            },
        }
    };
</script>
<style>
    .result-class {
        height: 100% !important;
        width: 100% !important;
        background-size: 100% 100% !important; /*按比例缩放*/
        background-image: url("../../assets/images/match/wdzj2.png");
    }

</style>
